/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiCriteriaInputDataSchema = z.object({
	mustHave: z.array(z.string()).nullable().optional().default([]),
	niceToHave: z.array(z.string()).nullable().optional().default([]),
})

export type WhatsAppAiCriteriaInputDataSchema = z.infer<typeof whatsAppAiCriteriaInputDataSchema>
